import { RelayPageDataTable } from "@constellation-academy/epic-ui";
import React, { useContext } from "react";
import { useTranslation } from "@i18n/hooks";
import { messageDefinitionsTable_MessageDefinitionFragment$key } from "@relay/messageDefinitionsTable_MessageDefinitionFragment.graphql";
import { messageDefinitionsTable_QueryFragment$key } from "@relay/messageDefinitionsTable_QueryFragment.graphql";
import { messageDefinitionsTable_Refetch } from "@relay/messageDefinitionsTable_Refetch.graphql";
import { CreateMessageDispatchButton } from "./create-message-dispatch-button";
import { DeleteMessageDefinitionButton } from "./delete-message-definition-button";
import { EditMessageDefinitionButton } from "./edit-message-definition-button";
import { ROWS_COUNT } from "./message-definitions-table.const";
import { MESSAGE_DEFINITION_FRAGMENT, QUERY_FRAGMENT } from "./message-definitions-table.graphql";
import { buttonWrapperClass } from "./message-definitions-table.styles";
import { MessageDefinitionsTableProps } from "./message-definitions-table.types";
import { DateTimeDisplay } from "../../../../components/DateTimeDisplay";
import { MessageDefinitionsContext } from "../../message-definitions.context";

export const MessageDefinitionsTable = ({
	messageDefinitionsFragmentRef,
}: MessageDefinitionsTableProps) => {
	const { t } = useTranslation("common");

	const { setConnectionId, filters } = useContext(MessageDefinitionsContext);

	const handleOnConnectionIdChange = (id?: string | null) => {
		id && setConnectionId(id);
	};

	return (
		<RelayPageDataTable<
			messageDefinitionsTable_Refetch,
			messageDefinitionsTable_QueryFragment$key,
			messageDefinitionsTable_MessageDefinitionFragment$key
		>
			queryFragment={QUERY_FRAGMENT}
			parentFragmentRef={messageDefinitionsFragmentRef}
			nodeInlineFragment={MESSAGE_DEFINITION_FRAGMENT}
			extractConnection={(data) => data.Admin.MessageDefinitions.MessageDefinitions}
			onConnectionIdChange={handleOnConnectionIdChange}
			rowsCount={ROWS_COUNT}
			filters={filters}
			emptyMessage={t("messageDefinition.tableEmpty")}
		>
			{(Column) => (
				<>
					<Column header={t("forms.internalTitle")} body={(item) => item.internalTitle} />
					<Column
						header={t("table.createdAt")}
						body={(item) => <DateTimeDisplay value={item.createdAt} hideTimezone />}
					/>
					<Column
						header={t("messageDefinition.showUntil")}
						body={(item) => <DateTimeDisplay value={item.showUntil} hideTimezone />}
					/>
					<Column
						header={t("table.actions")}
						style={{ width: "20%" }}
						body={(item) => (
							<div className={buttonWrapperClass}>
								<CreateMessageDispatchButton messageDefinitionFragmentRef={item} />
								<EditMessageDefinitionButton messageDefinitionId={item.id} />
								<DeleteMessageDefinitionButton messageDefinitionId={item.id} />
							</div>
						)}
					/>
				</>
			)}
		</RelayPageDataTable>
	);
};
